'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Icon,
   Input,
   InputGroup,
   Spinner,
   Text,
   useColorMode,
   useColorModeValue,
   useDisclosure,
   useOutsideClick,
} from '@chakra-ui/react';
import Select from 'react-select';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteReportFormat, getReportFormat, getReportSerialWiseHistory } from '../../../../redux/actions/reports';
import ColumnShowHide from '../components/Columnshowhide';
import { useBusinessType, useGlobal } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { stockDrop, stockStatusDrop } from 'constants';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { motion } from 'framer-motion';
import { MdCompress, MdDelete, MdExpand } from 'react-icons/md';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import { useUser } from 'contexts';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LucideEdit } from 'lucide-react';
import { FiPlusCircle } from 'react-icons/fi';
import { IoFilterOutline } from 'react-icons/io5';
import ItemSerialwiseHistoryFilter from '../components/ItemSerialWiseHistoryFilter';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import { VariableSizeList } from 'react-window';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);
const DEBOUNCE_DELAY = 500;

const ItemSerialwiseHistory = () => {
   // Constants
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   // Context and Redux
   const { companyList } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const { businessTypes } = useBusinessType();
   const dispatch = useDispatch();
   const serialWiseHistory = useSelector((state) => state.reports?.serialWiseHistory || []);
   const dbName = localStorage.getItem('dbName');

   // Report format
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [reportType, setReportType] = useState('Default');
   const [editData, setEditData] = useState({});
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [showHideData, setShowHideData] = useState({});
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const fetchDataCalledRef = useRef(false);
   const prevDependenciesRef = useRef({});
   const allowedDefNames = ['Item + Serial-Wise History'];
   const dynamicOptions = useMemo(
      () =>
         reportformat
            .filter((item) => item?.defName && allowedDefNames.includes(item?.defName))
            .map((item) => ({
               id: item.id,
               value: item.defName && item.title,
               label: item.title,
               isDynamic: true,
               formatData: item,
            })),
      [reportformat],
   );

   const dynamicOptionValues = useMemo(
      () => dynamicOptions.find((option) => option.value === reportType),
      [dynamicOptions, reportType],
   );

   const isStaticReportType = ['Default'].includes(reportType);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { user } = useUser();
   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = useState(null);
   const [flattenedData, setFlattenedData] = useState([]);
   const [containerHeight, setContainerHeight] = useState(700);
   const listRef = useRef(null);

   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else {
         return {};
      }
   });

   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);

   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityType === 'salereturn'
              ? viewDatasr?.data[0]
              : entityType === 'saleinvoice'
                ? viewDatasi
                : entityType === 'purchaseinvoice'
                  ? viewDatapi
                  : null;

      const pagination =
         entityType === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityType === 'salereturn'
              ? viewDatasr?.pagination
              : entityType === 'saleinvoice'
                ? viewDatasi?.pagination
                : entityType === 'purchaseinvoice'
                  ? viewDatapi?.pagination
                  : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      entityType,
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi,
      viewDatapi,
   ]);

   // Refs
   const abortControllerRef = useRef(null);
   const wrapperRef = useRef();
   const searchTimeoutRef = useRef();

   // State
   const [allExpanded, setAllExpanded] = useState(false);
   const [itemWiseSelected, setItemWiseSelected] = useState(null);
   const [stockWiseSelected, setStockWiseSelected] = useState(null);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [expandedItems, setExpandedItems] = useState({});
   const [searchQuery, setSearchQuery] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });

   // Disclosures
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [expanded, setExpanded] = useState(false);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   // Initialize expanded state for all items when data loads
   useEffect(() => {
      if (serialWiseHistory.length > 0) {
         const newExpanded = {};
         serialWiseHistory.forEach((companyData) => {
            const companyKey = `company-${companyData.companyId}`;
            newExpanded[companyKey] = true;

            if (companyData.items) {
               companyData.items.forEach((itemData) => {
                  const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
                  newExpanded[itemKey] = true;
               });
            }
         });
         setExpandedItems(newExpanded);
      }
   }, [serialWiseHistory]);

   // Memoized values
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
              ? [parseInt(localStorage.getItem('companyId'))]
              : [],
      [companyFilter],
   );

   // Initialize default values
   const storedCompanyId = localStorage.getItem('companyId');
   useEffect(() => {
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }

      if (businessTypes?.businessType === 'MOBILE') {
         setItemWiseSelected({ value: stockDrop[0].id, label: stockDrop[0].name });
         setStockWiseSelected({ value: stockStatusDrop[2].id, label: stockStatusDrop[2].name });
      }
   }, [companyList, businessTypes, storedCompanyId]);

   const groupItemsByItemId = useCallback((items) => {
      if (!items || items.length === 0) return [];

      // Use Map for better performance
      const groupedMap = new Map();

      for (const item of items) {
         if (!groupedMap.has(item.item_id)) {
            groupedMap.set(item.item_id, {
               item_id: item.item_id,
               item_name: item.item_name,
               total_transactions: 0,
               transactions: [],
            });
         }

         const existingItem = groupedMap.get(item.item_id);
         existingItem.total_transactions += item.total_transactions || 0;

         if (item.transactions && Array.isArray(item.transactions)) {
            existingItem.transactions.push(...item.transactions);
         }
      }

      return Array.from(groupedMap.values());
   }, []);

   // Optimized data fetching with proper loading states
   const fetchData = useCallback(
      async (searchTerm = '') => {
         // Validate inputs
         if (
            !Array.isArray(companyIds) ||
            companyIds.length === 0 ||
            companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0)
         ) {
            console.log('Invalid company IDs, skipping API call');
            return;
         }

         // Validate date range
         if (!dateRange.fromDate || !dateRange.toDate) {
            console.log('Date range missing, skipping API call');
            return;
         }

         // Cancel previous request
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }

         abortControllerRef.current = new AbortController();

         // Set loading state
         const loadingState = searchTerm ? setIsFilterLoading : setIsLoading;
         loadingState(true);

         try {
            const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

            if (validCompanyIds.length > 0) {
               await dispatch(
                  getReportSerialWiseHistory({
                     companyIds: validCompanyIds.join(','),
                     search: searchTerm.trim(),
                     fromDate: dateRange.fromDate,
                     toDate: dateRange.toDate,
                  }),
                  { signal: abortControllerRef.current.signal },
               );
            }
         } catch (error) {
            if (error.name !== 'AbortError') {
               console.error('Error fetching serial wise history:', error);
            }
         } finally {
            setIsLoading(false);
            setIsFilterLoading(false);
            abortControllerRef.current = null;
         }
      },
      [dispatch, companyIds, dateRange.fromDate, dateRange.toDate],
   );

   const flattenHierarchicalData = useCallback(
      (companies) => {
         const flatItems = [];

         companies.forEach((company) => {
            // Company header row
            flatItems.push({
               type: 'company',
               data: company,
               id: `company-${company.companyId}`,
               companyId: company.companyId,
               depth: 0,
               index: flatItems.length,
            });

            // Check if company is expanded
            if (expandedItems[`company-${company.companyId}`]) {
               const groupedItems = groupItemsByItemId(company.items);

               groupedItems.forEach((item) => {
                  // Item header row
                  flatItems.push({
                     type: 'item',
                     data: item,
                     companyId: company.companyId,
                     itemId: item.item_id,
                     id: `item-${item.item_id}-${company.companyId}`,
                     depth: 1,
                     index: flatItems.length,
                  });

                  // Check if item is expanded
                  if (expandedItems[`item-${item.item_id}-${company.companyId}`]) {
                     // Add transaction header
                     flatItems.push({
                        type: 'transaction-header',
                        data: null,
                        companyId: company.companyId,
                        itemId: item.item_id,
                        id: `trans-header-${item.item_id}-${company.companyId}`,
                        depth: 2,
                        index: flatItems.length,
                     });

                     // Add transaction rows
                     item.transactions.forEach((transaction, transIndex) => {
                        flatItems.push({
                           type: 'transaction',
                           data: transaction,
                           companyId: company.companyId,
                           itemId: item.item_id,
                           id: `trans-${transaction.id || transaction.doc_id}-${transIndex}`,
                           depth: 2,
                           index: flatItems.length,
                        });
                     });
                  }
               });
            }
         });

         return flatItems;
      },
      [expandedItems, groupItemsByItemId],
   );

   useEffect(() => {
      if (serialWiseHistory.length > 0) {
         const flat = flattenHierarchicalData(serialWiseHistory);
         setFlattenedData(flat);

         // Reset list to recalculate heights
         if (listRef.current) {
            listRef.current.resetAfterIndex(0);
         }
      }
   }, [serialWiseHistory, expandedItems, flattenHierarchicalData]);

   useEffect(() => {
      const calculateHeight = () => {
         const windowHeight = window.innerHeight;
         const headerHeight = 250; // Adjust based on your header/filters height
         const cardMargin = 15;
         const padding = 32;

         const availableHeight = windowHeight - headerHeight - cardMargin - padding;
         setContainerHeight(Math.max(availableHeight, 400)); // Minimum 400px
      };

      calculateHeight();
      window.addEventListener('resize', calculateHeight);
      return () => window.removeEventListener('resize', calculateHeight);
   }, []);

   // 5. Get item size (height) for each row
   const getItemSize = useCallback(
      (index) => {
         const item = flattenedData[index];
         if (!item) return 60;

         switch (item.type) {
            case 'company':
               return 80; // Company row height
            case 'item':
               return 70; // Item row height
            case 'transaction-header':
               return 50; // Table header height
            case 'transaction':
               return 50; // Transaction row height
            default:
               return 60;
         }
      },
      [flattenedData],
   );

   useEffect(() => {
      const currentDeps = {
         companyIds: JSON.stringify(companyIds),
         fromDate: dateRange.fromDate,
         toDate: dateRange.toDate,
      };

      const prevDeps = prevDependenciesRef.current;

      // Only call if dependencies actually changed
      if (
         currentDeps.companyIds !== prevDeps.companyIds ||
         currentDeps.fromDate !== prevDeps.fromDate ||
         currentDeps.toDate !== prevDeps.toDate
      ) {
         const hasValidCompanyIds =
            Array.isArray(companyIds) &&
            companyIds.length > 0 &&
            !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
         const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

         if (hasValidCompanyIds && hasValidDateRange && !fetchDataCalledRef.current) {
            fetchDataCalledRef.current = true;
            fetchData().finally(() => {
               fetchDataCalledRef.current = false;
            });
         }

         prevDependenciesRef.current = currentDeps;
      }
   }, [companyIds, dateRange.fromDate, dateRange.toDate, fetchData]);

   // Optimized search handler with proper debouncing
   const handleSearchChange = useCallback(
      (e) => {
         const value = e.target.value;
         setSearchQuery(value);

         // Clear previous timeout
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }

         // Set new timeout for debounced search
         searchTimeoutRef.current = setTimeout(() => {
            fetchData(value);
         }, DEBOUNCE_DELAY);
      },
      [fetchData],
   );

   // Cleanup timeouts on unmount
   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }
      };
   }, []);

   // Auto-fetch data when dependencies change
   useEffect(() => {
      const hasValidCompanyIds =
         Array.isArray(companyIds) &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

      if (hasValidCompanyIds && hasValidDateRange) {
         fetchData();
      }
   }, [companyIds, dateRange.fromDate, dateRange.toDate]);

   const fetchReportType = useCallback(async () => {
      await dispatch(getReportFormat());
   }, [dispatch]);

   useEffect(() => {
      fetchReportType();
   }, [fetchReportType]);

   // Handlers
   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const expandAll = useCallback(() => {
      const newExpanded = {};
      serialWiseHistory.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         if (companyData.items) {
            companyData.items.forEach((itemData) => {
               const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
               newExpanded[itemKey] = true;
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(true);
   }, [serialWiseHistory]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      serialWiseHistory.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         if (companyData.items) {
            companyData.items.forEach((itemData) => {
               const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
               newExpanded[itemKey] = false;
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(false);
   }, [serialWiseHistory]);

   const handleRefresh = useCallback(() => {
      fetchData(searchQuery);
   }, [fetchData, searchQuery]);

   const toggleExpand = useCallback((id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   }, []);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   }, []);

   // Formatting functions
   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
   }, []);

   // Optimized export functions (keeping the same implementation but adding early returns)
   const exportToExcel = () => {
      if (!serialWiseHistory || serialWiseHistory.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new workbook
         const wb = XLSX.utils.book_new();
         const wsData = [];

         // Check if xlsx-js-style is available for advanced styling
         const hasXLSXStyle = typeof XLSXStyle !== 'undefined' || typeof XLSX.writeFileXLSX !== 'undefined';

         // Helper function to create styled cells
         const createStyledCell = (value, style = {}) => {
            // Basic cell structure
            const cell = {
               v: value,
               t: typeof value === 'number' ? 'n' : 's',
            };

            // Only add styles if xlsx-js-style is available
            if (hasXLSXStyle && style && Object.keys(style).length > 0) {
               cell.s = style;
            }

            return cell;
         };

         // Helper function to convert backend color to Excel RGB (6 digits)
         const convertBackendColorToExcel = (backendColor) => {
            if (!backendColor) return '000000';

            if (backendColor.startsWith('#')) {
               return backendColor.substring(1).toUpperCase().padStart(6, '0');
            }

            if (backendColor.startsWith('0xff') || backendColor.startsWith('0xFF')) {
               const hex = backendColor.substring(4);
               return hex.toUpperCase().padStart(6, '0');
            }

            return '000000';
         };

         // Get column configuration based on static or dynamic format
         const getColumnConfig = () => {
            // For static format, use predefined columns
            if (isStaticReportType) {
               let staticColumns = [];

               if (itemWiseSelected?.value === 0) {
                  // Item + Serial-Wise
                  staticColumns = [
                     { key: 'serial_no', title: 'Serial No', accessor: 'serial_no', width: 20 },
                     { key: 'transaction_at', title: 'Date', accessor: 'transaction_at', isDate: true, width: 15 },
                     { key: 'daybook_name', title: 'Daybook', accessor: 'daybook_name', width: 20 },
                     { key: 'doc_no', title: 'Doc', accessor: 'doc_no', width: 15 },
                     { key: 'account_name', title: 'Party', accessor: 'account_name', width: 25 },
                     { key: 'item_rate', title: 'Item Rate', accessor: 'item_rate', isNumeric: true, width: 15 },
                     {
                        key: 'quantity_factor',
                        title: 'Quantity',
                        accessor: 'quantity_factor',
                        isNumeric: true,
                        width: 15,
                     },
                     { key: 'line_amount', title: 'Amount', accessor: 'line_amount', isNumeric: true, width: 15 },
                  ];
               } else if (itemWiseSelected?.value === 1) {
                  // Item-wise
                  staticColumns = [
                     { key: 'item_name', title: 'Item Name', accessor: 'item_name', width: 30 },
                     {
                        key: 'total_transactions',
                        title: 'Quantity',
                        accessor: 'total_transactions',
                        isNumeric: true,
                        width: 20,
                     },
                     { key: 'total_amount', title: 'Amount', accessor: 'total_amount', isNumeric: true, width: 20 },
                  ];
               } else if (itemWiseSelected?.value === 2) {
                  // Serial-Wise
                  staticColumns = [
                     { key: 'serial_no', title: 'Serial No', accessor: 'serial_no', width: 20 },
                     { key: 'transaction_at', title: 'Date', accessor: 'transaction_at', isDate: true, width: 15 },
                     { key: 'daybook_name', title: 'Daybook', accessor: 'daybook_name', width: 20 },
                     { key: 'doc_no', title: 'Doc', accessor: 'doc_no', width: 15 },
                     { key: 'account_name', title: 'Party', accessor: 'account_name', width: 25 },
                     { key: 'transaction_type', title: 'Transaction Type', accessor: 'transaction_type', width: 20 },
                     { key: 'line_amount', title: 'Amount', accessor: 'line_amount', isNumeric: true, width: 15 },
                  ];
               }

               // Add default styling config for static columns
               return staticColumns.map((col) => ({
                  ...col,
                  config: {
                     title: col.title,
                     isShow: true,
                     color: '000000', // Black for static
                     isBold: false,
                     isItalic: false,
                     orderNo: 0,
                     flex: 1,
                  },
               }));
            }

            // For dynamic format, use configuration from viewJson
            const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

            const getColumnInfo = (defName) => {
               const viewItem = viewJson.find(
                  (item) =>
                     item?.defName?.toLowerCase() === defName.toLowerCase() ||
                     item?.title?.toLowerCase() === defName.toLowerCase(),
               );

               if (!viewItem) {
                  return {
                     title: defName,
                     isShow: true,
                     color: '000000',
                     isBold: false,
                     isItalic: false,
                     orderNo: 0,
                     flex: 1,
                  };
               }

               return {
                  title: viewItem.title || defName,
                  isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
                  color: viewItem.color ? convertBackendColorToExcel(viewItem.color) : '000000',
                  isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
                  isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
                  orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
                  flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
               };
            };

            // Define all possible columns based on view type
            let allColumns = [];

            // Safe access to itemWiseSelected
            const viewValue = itemWiseSelected?.value ?? 0;

            if (viewValue === 0) {
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no', width: 20 },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true, width: 15 },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name', width: 20 },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no', width: 15 },
                  { key: 'account_name', defName: 'party', accessor: 'account_name', width: 25 },
                  { key: 'item_rate', defName: 'itemrate', accessor: 'item_rate', isNumeric: true, width: 15 },
                  {
                     key: 'quantity_factor',
                     defName: 'quantity',
                     accessor: 'quantity_factor',
                     isNumeric: true,
                     width: 15,
                  },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true, width: 15 },
               ];
            } else if (viewValue === 1) {
               allColumns = [
                  { key: 'item_name', defName: 'itemname', accessor: 'item_name', width: 30 },
                  {
                     key: 'total_transactions',
                     defName: 'quantity',
                     accessor: 'total_transactions',
                     isNumeric: true,
                     width: 20,
                  },
                  { key: 'total_amount', defName: 'amt', accessor: 'total_amount', isNumeric: true, width: 20 },
               ];
            } else if (viewValue === 2) {
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no', width: 20 },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true, width: 15 },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name', width: 20 },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no', width: 15 },
                  { key: 'account_name', defName: 'party', accessor: 'account_name', width: 25 },
                  { key: 'transaction_type', defName: 'transactiontype', accessor: 'transaction_type', width: 20 },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true, width: 15 },
               ];
            }

            const configuredColumns = allColumns
               .map((col) => ({ ...col, config: getColumnInfo(col.defName) }))
               .filter((col) => col.config.isShow !== false)
               .sort((a, b) => (a.config.orderNo || 0) - (b.config.orderNo || 0));

            return configuredColumns;
         };

         // Styles for Excel cells - simplified for better compatibility
         const styles = {
            reportTitle: {
               font: { bold: true, sz: 16 },
               alignment: { horizontal: 'center' },
               fill: { fgColor: { rgb: 'FFFFFF' } },
            },
            dateRange: {
               font: { italic: true, sz: 12 },
               alignment: { horizontal: 'center' },
            },
            companyHeader: {
               font: { bold: true, sz: 14, color: { rgb: '0000FF' } },
               fill: { fgColor: { rgb: 'E6E6FA' } },
               alignment: { horizontal: 'left' },
            },
            companyTotals: {
               font: { bold: true, sz: 12, color: { rgb: '0000FF' } },
               fill: { fgColor: { rgb: 'E6E6FA' } },
               alignment: { horizontal: 'left' },
            },
            tableHeader: {
               font: { bold: true, sz: 12 },
               fill: { fgColor: { rgb: 'F1F0E8' } },
               alignment: { horizontal: 'center' },
            },
            itemHeader: {
               font: { bold: true, sz: 11 },
               fill: { fgColor: { rgb: 'E6E6E6' } },
               alignment: { horizontal: 'left' },
            },
            totalRow: {
               font: { bold: true, sz: 11 },
               fill: { fgColor: { rgb: 'D3D3D3' } },
               alignment: { horizontal: 'left' },
            },
            oddRow: {
               font: { sz: 10 },
               fill: { fgColor: { rgb: 'FFFFFF' } },
            },
            evenRow: {
               font: { sz: 10 },
               fill: { fgColor: { rgb: 'F8FAFC' } },
            },
         };

         const columnConfig = getColumnConfig();
         let currentRow = 0;
         const mergeRanges = [];

         // Safe date formatting
         const safeDateFormat = (dateValue) => {
            try {
               if (!dateValue) return '';
               if (typeof formatDateToDDMMYYYY === 'function') {
                  return formatDateToDDMMYYYY(dateValue);
               }
               // Fallback date formatting
               const date = new Date(dateValue);
               if (isNaN(date.getTime())) return dateValue.toString();
               return date.toLocaleDateString('en-GB');
            } catch (error) {
               console.warn('Date formatting error:', error);
               return dateValue?.toString() || '';
            }
         };

         // Helper function to format cell value
         const formatCellValue = (value, column) => {
            try {
               if (value === null || value === undefined) return '';
               if (value === 0) return 0;

               if (column?.isDate && value) {
                  return safeDateFormat(value);
               }
               if (column?.isNumeric) {
                  const numValue = parseFloat(value);
                  return isNaN(numValue) ? 0 : numValue;
               }
               return value.toString();
            } catch (error) {
               console.warn('Cell value formatting error:', error);
               return '';
            }
         };

         // Helper function to get cell style with dynamic formatting
         const getCellStyle = (baseStyle, column, rowIndex = 0) => {
            try {
               let cellStyle = JSON.parse(JSON.stringify(baseStyle));

               // Apply dynamic formatting if available and xlsx-js-style is present
               if (hasXLSXStyle && column?.config) {
                  if (column.config.color && column.config.color !== '000000') {
                     cellStyle.font = cellStyle.font || {};
                     cellStyle.font.color = { rgb: column.config.color };
                  }
                  if (column.config.isBold) {
                     cellStyle.font = cellStyle.font || {};
                     cellStyle.font.bold = true;
                  }
                  if (column.config.isItalic) {
                     cellStyle.font = cellStyle.font || {};
                     cellStyle.font.italic = true;
                  }
               }

               // Apply specific formatting based on column type
               if (column) {
                  if (column.isNumeric) {
                     cellStyle.numFmt = '#,##0.00';
                     cellStyle.alignment = cellStyle.alignment || {};
                     cellStyle.alignment.horizontal = 'right';
                  } else if (column.isDate) {
                     cellStyle.numFmt = 'dd-mm-yyyy';
                     cellStyle.alignment = cellStyle.alignment || {};
                     cellStyle.alignment.horizontal = 'center';
                  } else {
                     cellStyle.alignment = cellStyle.alignment || {};
                     cellStyle.alignment.horizontal = 'left';
                  }
               }

               return cellStyle;
            } catch (error) {
               console.warn('Style generation error:', error);
               return baseStyle;
            }
         };

         // Safe date range formatting
         const fromDateStr = dateRange?.fromDate ? safeDateFormat(dateRange.fromDate) : 'N/A';
         const toDateStr = dateRange?.toDate ? safeDateFormat(dateRange.toDate) : 'N/A';

         // Add report title
         wsData.push([createStyledCell('Item + Serialwise History Report', styles.reportTitle)]);
         mergeRanges.push({
            s: { r: currentRow, c: 0 },
            e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
         });
         currentRow++;

         // Add date range
         wsData.push([createStyledCell(`From ${fromDateStr} to ${toDateStr}`, styles.dateRange)]);
         mergeRanges.push({
            s: { r: currentRow, c: 0 },
            e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
         });
         currentRow++;

         // Add format type if dynamic
         if (!isStaticReportType) {
            wsData.push([createStyledCell(`Format: ${reportType || 'Dynamic'}`, styles.dateRange)]);
            mergeRanges.push({
               s: { r: currentRow, c: 0 },
               e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
            });
            currentRow++;
         }

         wsData.push([]); // Empty row
         currentRow++;

         // Safe data processing with proper null checks
         if (!Array.isArray(serialWiseHistory)) {
            throw new Error('serialWiseHistory is not an array');
         }

         // Process each company
         serialWiseHistory.forEach((companyData, companyIndex) => {
            try {
               if (!companyData || !companyData.items) {
                  console.warn(`Company data at index ${companyIndex} is invalid:`, companyData);
                  return; // Skip invalid company data
               }

               // Group items by item ID
               let groupedItems = [];
               if (typeof groupItemsByItemId === 'function') {
                  groupedItems = groupItemsByItemId(companyData.items);
               } else {
                  // Fallback grouping logic
                  groupedItems = companyData.items.map((item) => ({
                     ...item,
                     transactions: item.transactions || [],
                  }));
               }

               // Calculate company totals with safe arithmetic
               const companyTotals = groupedItems.reduce(
                  (acc, item) => {
                     if (!item || !Array.isArray(item.transactions)) {
                        return acc;
                     }

                     const itemTotal = item.transactions.reduce(
                        (subAcc, transaction) => {
                           const amount = parseFloat(transaction?.line_amount) || 0;
                           return {
                              transactions: subAcc.transactions + 1,
                              amount: subAcc.amount + amount,
                           };
                        },
                        { transactions: 0, amount: 0 },
                     );
                     return {
                        transactions: acc.transactions + itemTotal.transactions,
                        amount: acc.amount + itemTotal.amount,
                     };
                  },
                  { transactions: 0, amount: 0 },
               );

               // Add company header
               const companyName = companyData.companyName || `Company ${companyIndex + 1}`;
               wsData.push([createStyledCell(companyName, styles.companyHeader)]);
               mergeRanges.push({
                  s: { r: currentRow, c: 0 },
                  e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
               });
               currentRow++;

               // Add company totals
               const companyTotalCells = [];
               companyTotalCells.push(createStyledCell('', styles.companyTotals));
               companyTotalCells.push(
                  createStyledCell(`Total Qty: ${companyTotals.transactions}`, styles.companyTotals),
               );
               companyTotalCells.push(
                  createStyledCell(
                     `Total Amount: ₹${companyTotals.amount.toLocaleString('en-IN')}`,
                     styles.companyTotals,
                  ),
               );

               // Fill remaining cells with styled empty cells
               while (companyTotalCells.length < Math.max(columnConfig.length, 8)) {
                  companyTotalCells.push(createStyledCell('', styles.companyTotals));
               }

               wsData.push(companyTotalCells);
               currentRow++;

               wsData.push([]); // Empty row
               currentRow++;

               // Add table headers with column-specific styling
               const headers = columnConfig.map((col) => {
                  const headerStyle = JSON.parse(JSON.stringify(styles.tableHeader));

                  // Apply column-specific styling for dynamic format
                  if (!isStaticReportType && hasXLSXStyle && col.config) {
                     if (col.config.color && col.config.color !== '000000') {
                        headerStyle.font = headerStyle.font || {};
                        headerStyle.font.color = { rgb: col.config.color };
                     }
                     if (col.config.isBold) {
                        headerStyle.font = headerStyle.font || {};
                        headerStyle.font.bold = true;
                     }
                     if (col.config.isItalic) {
                        headerStyle.font = headerStyle.font || {};
                        headerStyle.font.italic = true;
                     }
                  }

                  return createStyledCell(col.config?.title || col.title || col.defName, headerStyle);
               });

               wsData.push(headers);
               currentRow++;

               // Process items based on view type with better error handling
               const viewValue = itemWiseSelected?.value ?? 0;

               if (viewValue === 0) {
                  // Item + Serial-Wise
                  groupedItems.forEach((item, itemIndex) => {
                     try {
                        if (!item || !Array.isArray(item.transactions)) {
                           console.warn(`Item at index ${itemIndex} is invalid:`, item);
                           return;
                        }

                        const itemTotal = item.transactions.reduce(
                           (sum, trans) => sum + (parseFloat(trans?.line_amount) || 0),
                           0,
                        );

                        // Add item header row
                        const itemHeaderRow = [];
                        const itemName = item.item_name || `Item ${itemIndex + 1}`;
                        const totalTransactions = item.total_transactions || item.transactions.length;

                        itemHeaderRow.push(
                           createStyledCell(
                              `${itemName} - Total Qty: ${totalTransactions} | Total Amount: ₹${itemTotal.toLocaleString(
                                 'en-IN',
                              )}`,
                              styles.itemHeader,
                           ),
                        );

                        // Fill remaining cells with styled empty cells
                        for (let i = 1; i < columnConfig.length; i++) {
                           itemHeaderRow.push(createStyledCell('', styles.itemHeader));
                        }

                        wsData.push(itemHeaderRow);
                        mergeRanges.push({
                           s: { r: currentRow, c: 0 },
                           e: { r: currentRow, c: columnConfig.length - 1 },
                        });
                        currentRow++;

                        // Add transactions with column-specific styling
                        item.transactions.forEach((transaction, transIndex) => {
                           try {
                              const baseRowStyle = transIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

                              const transactionRow = columnConfig.map((col) => {
                                 const value = formatCellValue(transaction?.[col.accessor], col);
                                 const cellStyle = getCellStyle(baseRowStyle, col, transIndex);
                                 return createStyledCell(value, cellStyle);
                              });

                              wsData.push(transactionRow);
                              currentRow++;
                           } catch (transError) {
                              console.warn(`Error processing transaction ${transIndex}:`, transError);
                           }
                        });

                        wsData.push([]); // Empty row after each item
                        currentRow++;
                     } catch (itemError) {
                        console.warn(`Error processing item ${itemIndex}:`, itemError);
                     }
                  });
               } else if (viewValue === 1) {
                  // Item-wise
                  groupedItems.forEach((item, itemIndex) => {
                     try {
                        const itemTotal =
                           item.transactions?.reduce((sum, trans) => sum + (parseFloat(trans?.line_amount) || 0), 0) ||
                           0;
                        const baseRowStyle = itemIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

                        const rowData = columnConfig.map((col) => {
                           let value = '';
                           if (col.key === 'item_name') value = item.item_name || '';
                           else if (col.key === 'total_transactions')
                              value = item.total_transactions || item.transactions?.length || 0;
                           else if (col.key === 'total_amount') value = itemTotal;

                           const cellStyle = getCellStyle(baseRowStyle, col, itemIndex);
                           return createStyledCell(value, cellStyle);
                        });

                        wsData.push(rowData);
                        currentRow++;
                     } catch (itemError) {
                        console.warn(`Error processing item-wise data ${itemIndex}:`, itemError);
                     }
                  });

                  // Add company totals row
                  const totalRowData = columnConfig.map((col) => {
                     let value = '';
                     if (col.key === 'item_name') value = 'Company Total';
                     else if (col.key === 'total_transactions') value = companyTotals.transactions;
                     else if (col.key === 'total_amount') value = companyTotals.amount;

                     return createStyledCell(value, styles.totalRow);
                  });

                  wsData.push(totalRowData);
                  currentRow++;
               } else if (viewValue === 2) {
                  // Serial-Wise
                  groupedItems.forEach((item, itemIndex) => {
                     try {
                        if (!item || !Array.isArray(item.transactions)) {
                           return;
                        }

                        const itemTotal = item.transactions.reduce(
                           (sum, trans) => sum + (parseFloat(trans?.line_amount) || 0),
                           0,
                        );

                        // Add item header row
                        const itemHeaderRow = [];
                        const itemName = item.item_name || `Item ${itemIndex + 1}`;
                        itemHeaderRow.push(
                           createStyledCell(
                              `${itemName} - Total Amount: ₹${itemTotal.toLocaleString('en-IN')}`,
                              styles.itemHeader,
                           ),
                        );

                        // Fill remaining cells with styled empty cells
                        for (let i = 1; i < columnConfig.length; i++) {
                           itemHeaderRow.push(createStyledCell('', styles.itemHeader));
                        }

                        wsData.push(itemHeaderRow);
                        mergeRanges.push({
                           s: { r: currentRow, c: 0 },
                           e: { r: currentRow, c: columnConfig.length - 1 },
                        });
                        currentRow++;

                        // Add transactions with column-specific styling
                        item.transactions.forEach((transaction, transIndex) => {
                           try {
                              const baseRowStyle = transIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

                              const rowData = columnConfig.map((col) => {
                                 const value = formatCellValue(transaction?.[col.accessor], col);
                                 const cellStyle = getCellStyle(baseRowStyle, col, transIndex);
                                 return createStyledCell(value, cellStyle);
                              });

                              wsData.push(rowData);
                              currentRow++;
                           } catch (transError) {
                              console.warn(`Error processing serial transaction ${transIndex}:`, transError);
                           }
                        });

                        wsData.push([]); // Empty row after each item
                        currentRow++;
                     } catch (itemError) {
                        console.warn(`Error processing serial-wise item ${itemIndex}:`, itemError);
                     }
                  });
               }

               wsData.push([]); // Empty row after each company
               currentRow++;
            } catch (companyError) {
               console.warn(`Error processing company ${companyIndex}:`, companyError);
            }
         });

         // Convert wsData to worksheet
         const ws = XLSX.utils.aoa_to_sheet(wsData);

         // Set column widths based on column configuration
         const colWidths = columnConfig.map((col) => ({ wch: col.width || 15 }));
         while (colWidths.length < 8) {
            colWidths.push({ wch: 15 });
         }
         ws['!cols'] = colWidths;

         // Add merge ranges safely
         if (mergeRanges.length > 0) {
            ws['!merges'] = mergeRanges;
         }

         // Add worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, 'Item Serialwise History');

         // Generate file name safely
         const now = new Date();
         const formatSuffix = isStaticReportType ? '_Static' : '_Dynamic';
         const safeFileName = `Item_Serialwise_History${formatSuffix}_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.xlsx`;

         // Write file - use XLSX.writeFileXLSX if available for styling
         if (hasXLSXStyle && typeof XLSX.writeFileXLSX !== 'undefined') {
            XLSX.writeFileXLSX(wb, safeFileName);
         } else {
            XLSX.writeFile(wb, safeFileName);
         }

         console.log('Excel export completed successfully');
      } catch (error) {
         console.error('Error exporting to Excel:', error);

         // More detailed error information
         if (error.message) {
            alert(`Failed to export Excel file: ${error.message}`);
         } else {
            alert('Failed to export Excel file. Please check the console for details.');
         }

         // Log additional debugging information
         console.log('Debug info:', {
            serialWiseHistoryLength: serialWiseHistory?.length,
            itemWiseSelected: itemWiseSelected,
            dateRange: dateRange,
            dynamicOptionValues: dynamicOptionValues,
            isStaticReportType: isStaticReportType,
         });
      }
   };

   const exportToPdf = () => {
      if (!serialWiseHistory || serialWiseHistory.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new PDF document
         const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
         });

         // Set document properties
         doc.setProperties({
            title: 'Item + Serialwise History Report',
            subject: 'Generated from application',
            author: 'Your Application',
            keywords: 'report, item, serialwise, history',
            creator: 'Your Application',
         });

         // Get page width for centering
         const pdfWidth = doc.internal.pageSize.getWidth();

         // Add title and date range
         doc.setFontSize(16);
         doc.setTextColor(0, 0, 0);
         doc.setFont('helvetica', 'bold');

         // Calculate center position for title
         const title = 'Item + Serialwise History Report';
         const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
         const titleX = (pdfWidth - titleWidth) / 2;
         doc.text(title, titleX, 15);

         doc.setFontSize(10);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(0, 0, 0);

         // Calculate center position for date range
         const dateText = `From ${formatDateToDDMMYYYY(dateRange.fromDate)} to ${formatDateToDDMMYYYY(
            dateRange.toDate,
         )}`;
         const dateWidth = (doc.getStringUnitWidth(dateText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
         const dateX = (pdfWidth - dateWidth) / 2;
         doc.text(dateText, dateX, 22);

         // Get dynamic column configuration
         const getColumnConfig = () => {
            const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

            const convertBackendColor = (backendColor) => {
               if (!backendColor) return [0, 0, 0]; // Default black
               if (backendColor.startsWith('#')) {
                  // Convert hex to RGB array for jsPDF
                  const hex = backendColor.substring(1);
                  const r = parseInt(hex.substring(0, 2), 16);
                  const g = parseInt(hex.substring(2, 4), 16);
                  const b = parseInt(hex.substring(4, 6), 16);
                  return [r, g, b];
               }
               if (backendColor.startsWith('0xff')) {
                  const hex = backendColor.substring(4);
                  const r = parseInt(hex.substring(0, 2), 16);
                  const g = parseInt(hex.substring(2, 4), 16);
                  const b = parseInt(hex.substring(4, 6), 16);
                  return [r, g, b];
               }
               return [0, 0, 0]; // Default black
            };

            const getColumnInfo = (defName) => {
               const viewItem = viewJson.find(
                  (item) =>
                     item?.defName?.toLowerCase() === defName.toLowerCase() ||
                     item?.title?.toLowerCase() === defName.toLowerCase(),
               );

               if (!viewItem || isStaticReportType) {
                  return {
                     title: defName,
                     isShow: true,
                     color: [0, 0, 0],
                     isBold: false,
                     isItalic: false,
                     orderNo: 0,
                     flex: 1,
                  };
               }

               return {
                  title: viewItem.title || defName,
                  isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
                  color: viewItem.color ? convertBackendColor(viewItem.color) : [0, 0, 0],
                  isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
                  isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
                  orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
                  flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
               };
            };

            // Define all possible columns based on view type
            let allColumns = [];

            if (itemWiseSelected?.value === 0) {
               // Item + Serial-Wise columns (excluding item_name as it will be a separate row)
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no' },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name' },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no' },
                  { key: 'account_name', defName: 'party', accessor: 'account_name' },
                  { key: 'item_rate', defName: 'itemrate', accessor: 'item_rate', isNumeric: true },
                  { key: 'quantity_factor', defName: 'quantity', accessor: 'quantity_factor', isNumeric: true },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true },
               ];
            } else if (itemWiseSelected?.value === 1) {
               // Item-wise columns
               allColumns = [
                  { key: 'item_name', defName: 'itemname', accessor: 'item_name' },
                  { key: 'total_transactions', defName: 'quantity', accessor: 'total_transactions', isNumeric: true },
                  { key: 'total_amount', defName: 'amt', accessor: 'total_amount', isNumeric: true },
               ];
            } else if (itemWiseSelected?.value === 2) {
               // Serial-Wise columns (excluding item_name as it will be a separate row)
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no' },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name' },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no' },
                  { key: 'account_name', defName: 'party', accessor: 'account_name' },
                  { key: 'transaction_type', defName: 'transactiontype', accessor: 'transaction_type' },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true },
               ];
            }

            // Get column configuration and filter visible columns
            const configuredColumns = allColumns
               .map((col) => ({
                  ...col,
                  config: getColumnInfo(col.defName),
               }))
               .filter((col) => col.config.isShow !== false)
               .sort((a, b) => (a.config.orderNo || 0) - (b.config.orderNo || 0));

            return configuredColumns;
         };

         const columnConfig = getColumnConfig();

         // Process each company
         let yPosition = 30;
         const pageWidth = doc.internal.pageSize.getWidth();
         const margin = 14;

         serialWiseHistory.forEach((companyData, companyIndex) => {
            const groupedItems = groupItemsByItemId(companyData.items);

            // Check if we need a new page
            if (yPosition > 180 && companyIndex > 0) {
               doc.addPage();
               yPosition = 15;
            }

            // Calculate company totals
            const companyTotals = groupedItems.reduce(
               (acc, item) => {
                  const itemTotal = item.transactions.reduce(
                     (subAcc, transaction) => {
                        const amount = parseFloat(transaction.line_amount) || 0;
                        return {
                           transactions: subAcc.transactions + 1,
                           amount: subAcc.amount + amount,
                        };
                     },
                     { transactions: 0, amount: 0 },
                  );
                  return {
                     transactions: acc.transactions + itemTotal.transactions,
                     amount: acc.amount + itemTotal.amount,
                  };
               },
               { transactions: 0, amount: 0 },
            );

            yPosition += 5;
            // Add company total row (like in the image)
            doc.setFillColor(241, 240, 232); // Light gray background
            doc.rect(margin, yPosition - 5, pageWidth - 2 * margin, 8, 'F');

            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(0, 0, 0);

            // Format the company total row similar to the image
            const companyTotalText = `${
               companyData.companyName
            }                             Qty : ${companyTotals.transactions.toLocaleString()}   ||  Amt: ${companyTotals.amount.toLocaleString()}`;
            doc.text(companyTotalText, margin, yPosition);
            yPosition += 2;
            // Prepare headers and column styles from configuration
            const headers = columnConfig.map((col) => col.config.title);
            const columnStyles = {};

            columnConfig.forEach((col, index) => {
               const alignment = col.isNumeric ? 'right' : col.isDate ? 'center' : 'left';
               columnStyles[index] = {
                  cellWidth: 'auto',
                  halign: alignment,
                  textColor: col.config.color,
                  fontStyle: col.config.isBold ? 'bold' : col.config.isItalic ? 'italic' : 'normal',
               };
            });

            // Prepare table data based on view type
            let tableData = [];

            const formatCellValue = (value, column) => {
               if (!value && value !== 0) return '';

               if (column.isDate && value) {
                  return formatDateToDDMMYYYY(value);
               }
               if (column.isNumeric) {
                  const numValue = parseFloat(value) || 0;
                  return column.key.includes('amount') || column.key.includes('rate')
                     ? `${numValue.toLocaleString()}`
                     : numValue.toString();
               }
               return value.toString();
            };

            if (itemWiseSelected?.value === 0) {
               // Item + Serial-Wise
               groupedItems.forEach((item) => {
                  // Add item header row spanning all columns
                  const itemTotal = item.transactions.reduce(
                     (sum, trans) => sum + parseFloat(trans.line_amount || 0),
                     0,
                  );

                  // Create item header row with item name and total
                  const itemHeaderRow = new Array(columnConfig.length).fill('');
                  itemHeaderRow[0] = {
                     content: `${item.item_name} - Total Qty: ${
                        item.total_transactions
                     } | Total Amount: ${itemTotal.toLocaleString()}`,
                     colSpan: columnConfig.length,
                     styles: {
                        fontStyle: 'bold',
                        fillColor: [230, 230, 230],
                        textColor: [0, 0, 0],
                        halign: 'left',
                     },
                  };

                  tableData.push(itemHeaderRow);

                  // Add transactions for this item
                  item.transactions.forEach((transaction) => {
                     const transactionRowData = columnConfig.map((col) => {
                        const value = transaction[col.accessor];
                        return formatCellValue(value, col);
                     });
                     tableData.push(transactionRowData);
                  });
               });
            } else if (itemWiseSelected?.value === 1) {
               // Item-wise
               groupedItems.forEach((item) => {
                  const itemTotal = item.transactions.reduce(
                     (sum, trans) => sum + parseFloat(trans.line_amount || 0),
                     0,
                  );

                  const rowData = columnConfig.map((col) => {
                     if (col.key === 'item_name') return item.item_name;
                     if (col.key === 'total_transactions') return item.total_transactions.toString();
                     if (col.key === 'total_amount') return `${itemTotal.toLocaleString()}`;
                     return '';
                  });

                  tableData.push(rowData);
               });

               // Add company totals row
               const totalRowData = columnConfig.map((col) => {
                  if (col.key === 'item_name') {
                     return { content: 'Company Total', styles: { fontStyle: 'bold' } };
                  } else if (col.key === 'total_transactions') {
                     return { content: companyTotals.transactions.toString(), styles: { fontStyle: 'bold' } };
                  } else if (col.key === 'total_amount') {
                     return { content: `${companyTotals.amount.toLocaleString()}`, styles: { fontStyle: 'bold' } };
                  }
                  return '';
               });
               tableData.push(totalRowData);
            } else if (itemWiseSelected?.value === 2) {
               // Serial-Wise - Group by item and show item name as header row
               groupedItems.forEach((item) => {
                  // Add item header row spanning all columns
                  const itemTotal = item.transactions.reduce(
                     (sum, trans) => sum + parseFloat(trans.line_amount || 0),
                     0,
                  );

                  const itemHeaderRow = new Array(columnConfig.length).fill('');
                  itemHeaderRow[0] = {
                     content: `${item.item_name} - Total Amount: ${itemTotal.toLocaleString()}`,
                     colSpan: columnConfig.length,
                     styles: {
                        fontStyle: 'bold',
                        fillColor: [230, 230, 230],
                        textColor: [0, 0, 0],
                        halign: 'left',
                     },
                  };

                  tableData.push(itemHeaderRow);

                  // Add transactions for this item
                  item.transactions.forEach((transaction) => {
                     const rowData = columnConfig.map((col) => {
                        const value = transaction[col.accessor];
                        return formatCellValue(value, col);
                     });
                     tableData.push(rowData);
                  });
               });
            }

            // Generate the table
            doc.autoTable({
               head: [headers],
               body: tableData,
               startY: yPosition,
               margin: { left: margin, right: margin },
               styles: {
                  fontSize: 8,
                  cellPadding: 2,
                  overflow: 'linebreak',
                  valign: 'middle',
                  textColor: [0, 0, 0],
               },
               headStyles: {
                  fillColor: '#BBBBBB',
                  textColor: [0, 0, 0],
                  fontStyle: 'bold',
                  fontSize: 9,
                  halign: 'center',
               },
               alternateRowStyles: {
                  fillColor: [248, 250, 252],
               },
               columnStyles: columnStyles,
               didDrawPage: function (data) {
                  // Footer
                  const pageCount = doc.internal.getNumberOfPages();
                  doc.setFontSize(8);
                  doc.setFont('helvetica', 'bold');
                  doc.setTextColor(0, 0, 0);
                  doc.text(
                     `Page ${data.pageNumber} of ${pageCount}`,
                     pageWidth - margin,
                     doc.internal.pageSize.getHeight() - 5,
                     { align: 'right' },
                  );
               },
            });

            // Update yPosition for next company
            yPosition = doc.lastAutoTable.finalY + 10;
         });

         // Generate safe file name
         const now = new Date();
         const safeFileName = `Item_Serialwise_History_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.pdf`;

         // Save the PDF
         doc.save(safeFileName);
      } catch (error) {
         console.error('Error exporting to PDF:', error);
         alert('Failed to export PDF file. Please try again.');
      }
   };

   // Optimized view single data handler
   const handleViewSingleData = useCallback(
      async (id) => {
         await dispatch(getReceiveInventory(id));
         setIsOpenSingleViewinr(true);
      },
      [dispatch],
   );

   const handleSalesSingleDataViewClose = useCallback(() => {
      setIsOpenSingleViewinr();
   }, []);

   const deletePurchaseReturn = useCallback(() => {
      if (entityType === 'purchasereturn') {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'salereturn') {
         deleteRecord(
            viewDetail?.id,
            deleteSaleReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'saleinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deleteSaleInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'purchaseinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deletePurchaseInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      setIsOpenPurchaseReturnSingleView(false);
   }, [entityType, viewDetail, dispatch, user, userGlobalSettingsData, storedCompanyId]);

   const handleSalesDetailsClose = useCallback(() => {
      setIsOpenPurchaseReturnSingleView();
   }, []);

   // Memoized render functions

   // Optimized data handler with useCallback
   const handledata = useCallback(
      async (data, datacompanyId) => {
         const storedCompanyId = localStorage.getItem('companyId');
         const companyId = parseInt(storedCompanyId);

         if (datacompanyId === companyId && data.daybook_type === 20) {
            setEntityType('receivemaster');
            const response = await dispatch(getReceiveInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 19) {
            setEntityType('issuemaster');
            const response = await dispatch(getIssueInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 11) {
            setEntityType('purchaseinvoice');
            await dispatch(getPurchaseInvoice(data.doc_id));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 5) {
            setEntityType('saleinvoice');
            await dispatch(getSaleInvoice(data.doc_id));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 12) {
            setEntityType('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.id));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 6) {
            setEntityType('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
      },
      [dispatch, user],
   );

   // Report type handlers
   const staticReportTypeOptions = [{ value: 'Default', label: 'Default' }];
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;

   const reportTypeOptions = useMemo(
      () => [
         ...staticReportTypeOptions,
         ...(dynamicOptions.length > 0
            ? [
                 {
                    label: 'Custom Formats',
                    options: dynamicOptions,
                 },
              ]
            : []),
      ],
      [dynamicOptions],
   );

   const handleReportTypeChange = useCallback(
      (selectedOption) => {
         setReportType(selectedOption.value);
         setExpandedItems({});
         dispatch(getReportFormat());
      },
      [dispatch],
   );

   const handleDeleteFormat = useCallback(
      async (id) => {
         try {
            await dispatch(deleteReportFormat(id));
            if (editData?.id === id) {
               setIsEditShowHide(false);
               setEditData({});
            }
            dispatch(getReportFormat());
         } catch (error) {
            console.error('Delete error:', error);
         }
      },
      [dispatch, editData],
   );

   const formatOptionLabel = useCallback(
      ({ label, isDynamic, id }, { context }) => (
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{label}</span>
            {isDynamic && context === 'menu' && (
               <button
                  onClick={(e) => {
                     e.stopPropagation();
                     handleDeleteFormat(id);
                  }}
                  style={{
                     background: 'none',
                     border: 'none',
                     cursor: 'pointer',
                     color: '#ff4d4f',
                     padding: '0 5px',
                  }}
                  title="Delete this format">
                  <MdDelete />
               </button>
            )}
         </div>
      ),
      [handleDeleteFormat],
   );

   const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

   const handleShowHideFormOpen = useCallback(async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === reportType && f.defName === 'Item + Serial-Wise History');
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   }, [reportType, reportformat]);

   const CompanyRow = React.memo(({ companyData, isExpanded, onToggle, style }) => {
      // Early return if companyData is null/undefined
      if (!companyData) {
         console.warn('CompanyRow received null companyData');
         return null;
      }

      // Calculate total with safety
      const totalQty =
         companyData.items?.reduce((sum, item) => {
            return sum + (item?.total_transactions || 0);
         }, 0) || 0;

      return (
         <div style={style}>
            <Box
               bg="linear-gradient(135deg, #f8f9ff 0%, #e8e9ff 100%)"
               borderLeft="6px solid #4f46e5"
               borderBottom="2px solid rgba(79, 70, 229, 0.15)"
               cursor="pointer"
               p={4}
               transition="all 0.3s"
               _hover={{
                  transform: 'translateX(4px)',
                  borderLeftColor: '#6366f1',
                  bg: 'linear-gradient(135deg, #ffffff 0%, #f0f1ff 100%)',
               }}
               onClick={onToggle}>
               <Flex justify="space-between" align="center">
                  <Text fontWeight="700" fontSize="lg" color={textColor}>
                     {companyData.companyName || 'Unknown Company'}
                  </Text>
                  <Flex align="center" gap={4}>
                     <Flex alignItems="center" gap={2} bg="rgba(79, 70, 229, 0.08)" px={3} py={1} borderRadius="full">
                        <Text fontSize="sm" opacity={0.8}>
                           Total Qty:
                        </Text>
                        <Text fontWeight="700">{totalQty}</Text>
                     </Flex>
                     <Icon as={isExpanded ? ChevronUpIcon : ChevronDownIcon} />
                  </Flex>
               </Flex>
            </Box>
         </div>
      );
   });

   const ItemRow = React.memo(({ itemData, isExpanded, onToggle, style }) => {
      const itemTotal = itemData.transactions?.reduce((sum, trans) => sum + (parseFloat(trans?.line_amount) || 0), 0);

      return (
         <div style={style}>
            <Box
               bg="linear-gradient(135deg, #fefefe 0%, #f1f5f9 100%)"
               borderLeft="4px solid #059669"
               cursor="pointer"
               p={3}
               transition="all 0.3s"
               _hover={{
                  bg: 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
                  transform: 'translateX(2px)',
               }}
               onClick={onToggle}>
               <Flex justify="space-between" align="center">
                  <Text fontWeight="600" fontSize="md">
                     {itemData.item_name}
                  </Text>
                  <Flex align="center" gap={2}>
                     <Flex alignItems="center" gap={2} bg="rgba(5, 150, 105, 0.08)" px={3} py={1} borderRadius="full">
                        <Text fontSize="sm">Total:</Text>
                        <Text fontWeight="700">{itemData.total_transactions}</Text>
                     </Flex>
                     <Flex alignItems="center" gap={2} bg="rgba(5, 150, 105, 0.1)" px={3} py={1} borderRadius="md">
                        <Text fontWeight="700" color="#059669">
                           ₹{itemTotal?.toLocaleString() || '0'}
                        </Text>
                     </Flex>
                     <Icon as={isExpanded ? ChevronUpIcon : ChevronDownIcon} boxSize={4} />
                  </Flex>
               </Flex>
            </Box>
         </div>
      );
   });

   const TransactionHeader = React.memo(({ style }) => {
      return (
         <div style={style}>
            <Box
               bg="#f8fafc"
               py={3}
               px={4}
               display="grid"
               gridTemplateColumns="1fr 1fr 2fr 2fr 2fr 1fr 1fr 1fr"
               gap={2}
               borderBottom="1px solid #e2e8f0">
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase">
                  Date
               </Text>
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase">
                  Doc#
               </Text>
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase">
                  Account
               </Text>
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase">
                  Serial No
               </Text>
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase">
                  Day Book
               </Text>
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase" textAlign="right">
                  Item Rate
               </Text>
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase" textAlign="right">
                  Quantity
               </Text>
               <Text fontSize="11px" fontWeight="700" color="#475569" textTransform="uppercase" textAlign="right">
                  Amount
               </Text>
            </Box>
         </div>
      );
   });

   const TransactionRow = React.memo(({ transaction, onClick, style }) => {
      return (
         <div style={style}>
            <Box
               onClick={onClick}
               cursor="pointer"
               py={2.5}
               px={4}
               display="grid"
               gridTemplateColumns="1fr 1fr 2fr 2fr 2fr 1fr 1fr 1fr"
               gap={2}
               _hover={{
                  bg: 'rgba(5, 150, 105, 0.05)',
               }}
               transition="background 0.2s">
               <Text fontSize="12px" fontWeight={500}>
                  {formatDateToDDMMYYYY(transaction.transaction_at)}
               </Text>
               <Text fontSize="12px" fontWeight={500}>
                  {transaction.doc_no}
               </Text>
               <Text fontSize="12px" fontWeight={500}>
                  {transaction.account_name}
               </Text>
               <Text fontSize="12px" fontWeight={500}>
                  {transaction.serial_no}
               </Text>
               <Text fontSize="12px" fontWeight={500}>
                  {transaction.daybook_name}
               </Text>
               <Text fontSize="12px" fontWeight={500} textAlign="right">
                  ₹{parseFloat(transaction.item_rate || 0).toLocaleString()}
               </Text>
               <Text fontSize="12px" fontWeight={500} textAlign="right">
                  {transaction.quantity_factor || 0}
               </Text>
               <Text fontSize="12px" fontWeight={500} textAlign="right">
                  ₹{parseFloat(transaction.line_amount || 0).toLocaleString()}
               </Text>
            </Box>
         </div>
      );
   });

   const RowRenderer = useCallback(
      ({ index, style }) => {
         const item = flattenedData[index];

         if (!item) return <div style={style} />;

         return (
            <div style={style}>
               {item.type === 'company' && (
                  <CompanyRow
                     companyData={item.data}
                     isExpanded={expandedItems[`company-${item.data.companyId}`]}
                     onToggle={() => toggleExpand(`company-${item.data.companyId}`)}
                     style={{ width: '100%' }}
                  />
               )}

               {item.type === 'item' && (
                  <ItemRow
                     itemData={item.data}
                     isExpanded={expandedItems[`item-${item.data.item_id}-${item.companyId}`]}
                     onToggle={() => toggleExpand(`item-${item.data.item_id}-${item.companyId}`)}
                     style={{ width: '100%' }}
                  />
               )}

               {item.type === 'transaction-header' && <TransactionHeader style={{ width: '100%' }} />}

               {item.type === 'transaction' && (
                  <TransactionRow
                     transaction={item.data}
                     onClick={() => handledata(item.data, item.companyId)}
                     style={{ width: '100%' }}
                  />
               )}
            </div>
         );
      },
      [flattenedData, expandedItems, toggleExpand, handledata],
   );

   return (
      <>
         {/* Header */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Item + Serialwise History
               </Text>
            </Flex>
            <Flex gap={2} alignItems="center">
               <Box cursor={'pointer'} onClick={handleShowHideFormOpen} mr={2}>
                  {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         {/* Filters */}
         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end' }}>
               <Flex flex="1" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <Box
                     my={2}
                     width="300px"
                     fontSize={'13px'}
                     mt={5}
                     fontWeight={500}
                     display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </Flex>
               <Flex flex="3" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Flex>
                     <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                        <label>Format</label>
                        <Select
                           options={reportTypeOptions}
                           formatOptionLabel={formatOptionLabel}
                           value={reportTypeOptions.find((option) => option.value === reportType)}
                           onChange={handleReportTypeChange}
                           placeholder="Select Report Type"
                           styles={{
                              control: (baseStyles, state) => ({
                                 ...baseStyles,
                                 minHeight: '30px',
                                 height: '30px',
                                 backgroundColor: controlBg,
                                 borderColor: controlBorder,
                                 boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                                 '&:hover': {
                                    borderColor: controlBorderHover,
                                 },
                              }),
                              valueContainer: (baseStyles) => ({
                                 ...baseStyles,
                                 height: '30px',
                                 padding: '0 6px',
                                 color: textColor,
                              }),
                              indicatorsContainer: (baseStyles) => ({
                                 ...baseStyles,
                                 height: '30px',
                              }),
                              singleValue: (baseStyles) => ({
                                 ...baseStyles,
                                 color: textColor,
                              }),
                              placeholder: (baseStyles) => ({
                                 ...baseStyles,
                                 color: placeholderColor,
                              }),
                              option: (baseStyles, state) => ({
                                 ...baseStyles,
                                 backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                                 color: textColor,
                                 fontWeight: state.data?.isDynamic ? 'bold' : 'normal',
                                 '&:hover': {
                                    backgroundColor: optionHoverBg,
                                 },
                              }),
                              groupHeading: (baseStyles) => ({
                                 ...baseStyles,
                                 backgroundColor: menuBg,
                                 border: `1px solid ${menuBorder}`,
                              }),
                              dropdownIndicator: (baseStyles) => ({
                                 ...baseStyles,
                                 color: indicatorColor,
                                 '&:hover': {
                                    color: indicatorHoverColor,
                                 },
                              }),
                              clearIndicator: (baseStyles) => ({
                                 ...baseStyles,
                                 color: indicatorColor,
                                 '&:hover': {
                                    color: indicatorHoverColor,
                                 },
                              }),
                           }}
                        />
                     </Box>
                  </Flex>
               </Flex>
               <Flex flex="1"></Flex>
               <Box flex="" mr={3}>
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '250px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <InputGroup width="200px">
                           <Input
                              placeholder="Search..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              variant="unstyled"
                              _focus={{ outline: 'none' }}
                           />
                           {isFilterLoading && (
                              <Spinner
                                 size="sm"
                                 position="absolute"
                                 right="8px"
                                 top="50%"
                                 transform="translateY(-50%)"
                              />
                           )}
                        </InputGroup>
                     )}
                  </MotionFlex>
               </Box>
               <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2} isLoading={isLoading}>
                  <LuRefreshCcw size={20} mr={2} />
               </Button>
               <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                  <IoFilterOutline size={22} />
               </Button>
               <Popover>
                  <PopoverTrigger>
                     <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                  </PopoverTrigger>
                  <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                     <PopoverBody p="3">
                        <Button
                           width="100%"
                           variant="ghost"
                           _hover={{ bg: 'blue.100' }}
                           onClick={exportToExcel}
                           justifyContent="space-between"
                           mb={3}>
                           <img src={xls} alt="Download XLS" width="30px"></img>
                           Download Excel
                        </Button>
                        <Button
                           width="100%"
                           variant="ghost"
                           _hover={{ bg: 'blue.100' }}
                           onClick={exportToPdf}
                           justifyContent="space-between">
                           <img src={xls} alt="Download pdf" width="30px" mr></img>
                           Download Pdf
                        </Button>
                     </PopoverBody>
                  </PopoverContent>
               </Popover>
               <Box ml="">
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               {/* Mobile Drawer */}
               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>

                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         {/* Table with loading states */}
         <Box
            bg={backgroundColor}
            className="px-3 pt-3 pb-3"
            mt="15px"
            borderRadius="7px"
            // height={`${containerHeight}px`}
            overflow="hidden"
            height="100%">
            <Box position="relative">
               {isLoading ? (
                  <Loader />
               ) : flattenedData.length === 0 ? (
                  <Box textAlign="center" py={10}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <Text mt={4}>No item + serialwise history data found</Text>
                  </Box>
               ) : (
                  <VariableSizeList
                     ref={listRef}
                     height={containerHeight}
                     width="100%"
                     itemCount={flattenedData.length}
                     itemSize={getItemSize}
                     overscanCount={15}>
                     {RowRenderer}
                  </VariableSizeList>
               )}
            </Box>
         </Box>

         {/* Modals and other components */}
         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={
               entityType === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityType === 'salereturn'
                    ? 'Sales Return'
                    : entityType === 'purchaseinvoice'
                      ? 'Purchase Invoice'
                      : 'Purchase Return'
            }
            entityType={entityType}
            singleEntity={viewDetail}
            handlePrevPage={() => console.log('Prev')}
            handleNextPage={() => console.log('Next')}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <ItemSerialwiseHistoryFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            entityType="itemserialwisehistory"
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityType}
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={[]} // You'll need to define columnsData properly
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={reportTypeOptions.dynamicOptions}
            FixdefName1={'Item + Serial-Wise History'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />
      </>
   );
};

export default ItemSerialwiseHistory;
